import { useMemo } from "react";

import { errorToast, infoToast, successToast, warningToast } from "../state/notifications";
import { useDispatch } from "./useTypedRedux";

export function useToast() {
  const dispatch = useDispatch();
  return useMemo(
    function () {
      return {
        error(message: string) {
          dispatch(errorToast({ message }));
        },
        info(message: string) {
          dispatch(infoToast({ message }));
        },
        success(message: string) {
          dispatch(successToast({ message }));
        },
        warning(message: string) {
          dispatch(warningToast({ message }));
        },
      };
    },
    [dispatch],
  );
}
